/**
 * Bangtan Mom - K-Drama Recommendation Seed Data
 * 
 * Updated with user-requested list and high-quality Unsplash fallbacks.
 */
export const kdramas = [
  {
    id: 'scarlet-heart-ryeo',
    title: 'Scarlet Heart Ryeo',
    slug: 'scarlet-heart-ryeo',
    image_url: 'https://images.unsplash.com/photo-1599839575945-a9e5af0c3fa5?w=1200&auto=format&fit=crop&q=80',
    tags: ['Historical', 'Romance', 'Tragedy'],
    synopsis_short: "A 21st-century woman is transported back to the Goryeo Dynasty during a total solar eclipse.",
    my_two_cents: "Prepare your tissues. This is a masterpiece of angst and beautiful cinematography. Lee Joon-gi is phenomenal.",
    is_featured_on_home: true,
    display_order: 1
  },
  {
    id: 'moon-embracing-the-sun',
    title: 'Moon Embracing the Sun',
    slug: 'moon-embracing-the-sun',
    image_url: 'https://images.unsplash.com/photo-1580226330962-4217f2252a12?w=1200&auto=format&fit=crop&q=80',
    tags: ['Historical', 'Fantasy', 'Romance'],
    synopsis_short: "The secret love story between a fictional King of the Joseon Dynasty and a female shaman.",
    my_two_cents: "Kim Soo-hyun's acting is top-tier. A classic historical drama that everyone should watch at least once.",
    is_featured_on_home: true,
    display_order: 2
  },
  {
    id: 'love-in-the-moonlight',
    title: 'Love in the Moonlight',
    slug: 'love-in-the-moonlight',
    image_url: 'https://images.unsplash.com/photo-1558591710-4b4a1ae0f04d?w=1200&auto=format&fit=crop&q=80',
    tags: ['Historical', 'Romance', 'Comedy'],
    synopsis_short: "A coming-of-age story about a Crown Prince's growth and his unlikely romance with a girl disguised as a eunuch.",
    my_two_cents: "Park Bo-gum radiates sunshine in this. It's lighthearted, sweet, and visually stunning.",
    is_featured_on_home: true,
    display_order: 3
  },
  {
    id: 'crash-landing-on-you',
    title: 'Crash Landing on You',
    slug: 'crash-landing-on-you',
    image_url: 'https://images.unsplash.com/photo-1518181282240-721245c38981?w=1200&auto=format&fit=crop&q=80',
    tags: ['Romance', 'Comedy', 'Drama'],
    synopsis_short: "A South Korean heiress accidentally paraglides into North Korea and into the life of an army officer.",
    my_two_cents: "The chemistry is real (they got married in real life!). Perfect balance of humor and heart-wrenching moments.",
    is_featured_on_home: true,
    display_order: 4
  },
  {
    id: 'you-are-my-destiny',
    title: 'You Are My Destiny',
    slug: 'you-are-my-destiny',
    image_url: 'https://images.unsplash.com/photo-1516589174184-c685245d4b63?w=1200&auto=format&fit=crop&q=80',
    tags: ['Romance', 'Drama', 'Family'],
    synopsis_short: "A chance encounter leads to an unexpected pregnancy and a forced marriage that eventually turns into true love.",
    my_two_cents: "The snail couple! Jang Hyuk's laugh is iconic. It's a roller coaster of emotions, but so rewarding.",
    is_featured_on_home: true,
    display_order: 5
  },
  {
    id: 'you-are-beautiful',
    title: 'You Are Beautiful',
    slug: 'you-are-beautiful',
    image_url: 'https://images.unsplash.com/photo-1493225255756-d9584f8606e9?w=1200&auto=format&fit=crop&q=80',
    tags: ['Music', 'Romance', 'Comedy'],
    synopsis_short: "A girl masquerades as her twin brother in a popular idol band, leading to a complicated web of secrets and feelings.",
    my_two_cents: "The ultimate second-lead syndrome starter. A nostalgic trip back to the 2009 idol era!",
    is_featured_on_home: true,
    display_order: 6
  },
  {
    id: 'the-goblin',
    title: 'The Goblin',
    slug: 'the-goblin',
    image_url: 'https://images.unsplash.com/photo-1478720568477-152d9b164e26?w=1200&auto=format&fit=crop&q=80',
    tags: ['Fantasy', 'Romance', 'Supernatural'],
    synopsis_short: "An immortal goblin searches for his human bride to end his cursed eternal life.",
    my_two_cents: "Gong Yoo and Lee Dong-wook's bromance is the best thing about this show (besides the epic soundtrack).",
    is_featured_on_home: true,
    display_order: 7
  },
  {
    id: 'mr-queen',
    title: 'Mr. Queen',
    slug: 'mr-queen',
    image_url: 'https://images.unsplash.com/photo-1533104816931-20fa691ff6ca?w=1200&auto=format&fit=crop&q=80',
    tags: ['Historical', 'Comedy', 'Body Swap'],
    synopsis_short: "A modern-day chef's soul gets trapped in the body of a Queen in the Joseon era.",
    my_two_cents: "Shin Hye-sun's performance is legendary. I haven't laughed this hard at a drama in years.",
    is_featured_on_home: true,
    display_order: 8
  },
  {
    id: 'bon-appetit-your-majesty',
    title: 'Bon Appetit Your Majesty',
    slug: 'bon-appetit-your-majesty',
    image_url: 'https://images.unsplash.com/photo-1556910103-1c02745aae4d?w=1200&auto=format&fit=crop&q=80',
    tags: ['Historical', 'Food', 'Comedy'],
    synopsis_short: "A delightful journey through Joseon royal cuisine mixed with palace intrigue and lighthearted romance.",
    my_two_cents: "A hidden gem for foodies. The cooking scenes are mesmerizing and the story is surprisingly sweet.",
    is_featured_on_home: true,
    display_order: 9
  }
];